// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImagesBlock_wrapper__n_9gB","imagesBlock":"ImagesBlock_imagesBlock___QCii","imgItem":"ImagesBlock_imgItem__Lj_QX","img":"ImagesBlock_img__mfEqz"};